import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';
import DropDownList from '../dropdown-list/index';
import SearchBox from '../search-box/index';
import '../../styles/core.scss';
import css from './index.scss';
import Button from '../button/index';
import { LIGHT } from '../button/variants';
import messages from './messages';

const findSelected = item => item.selected;

const StudentFilter = ({ lastNames, yearGroups, classrooms, searchTerm = '', handleFilterOnChange, handleFilterOnClear, handleOnSearch, intl }) => {
    const selectedYearGroup = yearGroups.find(findSelected);
    const selectedClassroom = classrooms.find(findSelected);

    const clonedLastNames = cloneDeep(lastNames);
    delete clonedLastNames['0'];

    const clonedYearGroup = cloneDeep(yearGroups);
    delete clonedYearGroup['0'];

    return (
        <div className={css.filterContainer}>
            <div className={css.filterContainer}>
                <div className={css.filters}>
                    <div className={css.year}>
                        <DropDownList
                            name="yearGroups"
                            onChange={handleFilterOnChange}
                            options={clonedYearGroup}
                            placeholder={intl.formatMessage(messages.allYears)}
                            value={selectedYearGroup.key} /></div>
                    <div className={css.class}>
                        <DropDownList
                            name="classrooms"
                            onChange={handleFilterOnChange}
                            options={classrooms}
                            value={selectedClassroom.key} /></div>
                    <Button
                        containerClassName={css.clear}
                        disabled={false}
                        handleOnClick={handleFilterOnClear}
                        label={intl.formatMessage(messages.clear)}
                        variant={LIGHT} />
                    <div className={css.studentSearchContainer}>
                        <SearchBox handleOnSearchClick={handleOnSearch} searchTerm={searchTerm} /></div>
                </div>
            </div>
        </div>
    );
};

StudentFilter.propTypes = {
    lastNames: PropTypes.array,
    yearGroups: PropTypes.array,
    classrooms: PropTypes.array,
    searchTerm: PropTypes.string,
    handleFilterOnChange: PropTypes.func,
    handleFilterOnClear: PropTypes.func,
    handleOnSearch: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(StudentFilter));



// WEBPACK FOOTER //
// ./app/components/student-filter/index.js